import { render, staticRenderFns } from "./ModuleProgress.vue?vue&type=template&id=3931d8c0&"
import script from "./ModuleProgress.vue?vue&type=script&lang=ts&"
export * from "./ModuleProgress.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports